export default __webpack_public_path__ + "static/item_17-c5f2d65c00e618fe36de9bc43b33e89d.jpg";